import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=609be54e&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('609be54e')) {
      api.createRecord('609be54e', component.options)
    } else {
      api.reload('609be54e', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=609be54e&", function () {
      api.rerender('609be54e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21Yv1baC93sym/JS/comp/stardisplay.vue"
export default component.exports